import { fromEventPattern } from 'rxjs';

export class EventBus {
    static $on (eventName, callback) {
        // Construct our callback object.
        const callbackObject = {
            callback,
            wrapper: (event) => {
                if (event.detail) callback(...event.detail);
                else callback();
            },
        };

        // Add the callback object to our callback store.
        if (EventBus.callbackStore[eventName] === undefined) EventBus.callbackStore[eventName] = [callbackObject];
        else EventBus.callbackStore[eventName].push(callbackObject);

        // Add our event listener.
        EventBus.bus.addEventListener(eventName, callbackObject.wrapper);
    }

    static $off (eventName, callback) {
        // Do we have any callbacks for this event name?
        if (EventBus.callbackStore[eventName] === undefined) return;

        // Find our callback index for the provided event name and callback.
        const callbackIndex = EventBus.callbackStore[eventName].findIndex((c) => c.callback === callback);
        if (callbackIndex === -1) return;

        // Remove our event listener.
        EventBus.bus.removeEventListener(eventName, EventBus.callbackStore[eventName][callbackIndex].wrapper);

        // Remove the callback object from our cache.
        EventBus.callbackStore[eventName].splice(callbackIndex, 1);
    }

    static $emit (event, ...args) {
        EventBus.bus.dispatchEvent(
            new CustomEvent(event, {
                detail: args,
            }),
        );
    }
}

EventBus.bus = document.createElement('div');
EventBus.callbackStore = {};

/**
 * Creates an RxJS observable from an EventBus event name.
 * Automatically unsubscribes when the observable is unsubscribed.
 *
 * @param eventName The string name of the event to observe
 */
export function eventToObservable (eventName) {
    return fromEventPattern(
        (handler) => EventBus.$on(eventName, handler),
        (handler) => EventBus.$off(eventName, handler),
    );
}
